/** Populated by `registerOfficeToolHandlers()` at chat mount. */ export const clientToolRegistry = {};
/** Run a registered client tool. Throws if the name is not registered. */ export function runClientTool(name, input, toolCallId) {
    const handler = clientToolRegistry[name];
    if (!handler) throw new Error(`No client tool handler registered for "${name}"`);
    return handler.execute(input, toolCallId);
}
export function isMutatingClientTool(name) {
    return Boolean(clientToolRegistry[name]?.mutatesDocument);
}
